import { render, staticRenderFns } from "./PageTrip.vue?vue&type=template&id=eabb995c&scoped=true&"
import script from "./PageTrip.vue?vue&type=script&lang=js&"
export * from "./PageTrip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eabb995c",
  null
  
)

export default component.exports